<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="modal-header checkout-popup-header">
      <h4 class="modal-title" id="modal-basic-title">
        {{ 'orderCheckOut.agreeTerms' | cxTranslate }}
      </h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="dismissModal('Cross click')"
      >
        <i class="material-icons custom-icons">close</i>
      </button>
    </div>
    <div class="modal-body checkout-popup">
      <h3 class="confirmation-order">
        {{ 'orderCheckOut.acknowledgeEndUserInfo' | cxTranslate }}
      </h3>
      <br />
      <h3 class="confirmation-order">
        {{ 'orderCheckOut.confirmRead' | cxTranslate }}
      </h3>
      <div>
        <a
          *ngFor="let pdfdownload of getPdf"
          [href]="constructURL(pdfdownload)"
          target="_blank"
          class="confirmation-link"
          >{{ 'orderCheckOut.downloadTermaNcond' | cxTranslate }}</a
        >
      </div>

      <div class="vs-checkbox custom-order-checkbox">
        <input
          id="term-condition"
          type="checkbox"
          value="true"
          [(ngModel)]="removeBtn"
          [ngModelOptions]="{ standalone: true }"
          name="terms-radio-group"
        />
        <label class="confirmation-label" for="term-condition">
          {{ 'orderCheckOut.agreeCondition' | cxTranslate }}
        </label>
      </div>
    </div>
    <div class="modal-footer checkout-popup-footer">
      <span class="mr" (click)="dismissModal('Cross click')"
        ><a class="footer-text-btn custom-color">{{
          'orderCheckOut.disAgree' | cxTranslate
        }}</a></span
      >
      <button
        (click)="postPlaceOrderDetails(); dismissModal('Cross click')"
        class="vs-primary-btn sample-btn footer-text-btn"
        [ngClass]="{ 'disabled-btn': getErrorsFlag }"
        [disabled]="!removeBtn"
      >
        {{ 'orderCheckOut.placeOrder' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
